import request from '../requesters/clientPortal'
import oathKeeper from '../requesters/oathKeeper'

export const getWebPushPublicKey = async () => {
  const useOathKeeper = sessionStorage.getItem('useOathKeeper')
  const requester = useOathKeeper === 'true' ? oathKeeper : request

  const response = await requester.get<WebPushPublicKey>('/notifications/webpush/public-key')
  return response.data
}

export const getWebPushSubscriptions = async () => {
  const useOathKeeper = sessionStorage.getItem('useOathKeeper')
  const requester = useOathKeeper === 'true' ? oathKeeper : request

  const response = await requester.get<WebPushSubscription[]>('/notifications/webpush/subscriptions')
  return response.data
}

export const subscribeWebPush = async (subscription: WebPushSubscriptionInput) => {
  const useOathKeeper = sessionStorage.getItem('useOathKeeper')
  const requester = useOathKeeper === 'true' ? oathKeeper : request

  const response = await requester.post<WebPushSubscription>('/notifications/webpush/subscriptions', subscription)
  return response.data
}

export const unsubscribeWebPush = async (id: string) => {
  const useOathKeeper = sessionStorage.getItem('useOathKeeper')
  const requester = useOathKeeper === 'true' ? oathKeeper : request

  const response = await requester.delete(`/notifications/webpush/subscriptions/${id}`)
  return response.status >= 200 && response.status < 300
}
